import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect, useState } from 'react';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import { DisplayListPagination } from '../../../components/TapUi';
import TapIcon from '../../../services/TapIcon';


const ModelListing = ({ history, location }) => {
    const [loading, setLoading] = useState(false);
    const [modelData, setModelData] = useState([]);
    const [listingMeta, setListingMeta] = useState(null);
    const access_token = useSelector(state => state.auth.access_token);

    const editModelInit = (item) => {
        history.push({ pathname: `/model_add`, state: { editModelData: item } });
    };
    const getModelListing = (page = 1) => {
        setLoading(true)
        const params = { page: page, per_page: 50, };
        HttpAPICall.withAthorization('GET', BACKOFFICE_BASE_URL + '/device_model_list', access_token, {}, params, (resp) => {
            const respData = resp.data
            setModelData(respData.data);
            setListingMeta({
                'from': respData.from,
                'to': respData.to,
                'total': respData.total,
                'last_page': respData.last_page,
                'per_page': respData.per_page,
                'current_page': respData.current_page
            });
        }).then(() => setLoading(false));

    }
    useEffect(() => {
        getModelListing(1)
    }, [])
    const modelListingJsx = () => {
        return (
            <>
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">

                        <tr>
                            <th className='text-center' style={{ width: "10%" }}>S.No.</th>
                            <th className='text-center ms-3' style={{ width: "40%" }}>Model Name</th>
                            <th className='text-center ms-3' style={{ width: "30%" }}>Manufacturer</th>
                            <th className='text-center ms-3' style={{ width: "20%" }}>Action</th>

                        </tr>
                    </thead>
                    <tbody>
                        {loading
                            ?
                            <tr><td colSpan={3}><Loader /></td></tr>
                            :
                            modelData.length > 0
                                ?
                                modelData.map((i, k) => {
                                    return (<>
                                        <tr key={k}>
                                            <>
                                                <td className='text-center'>{k + 1}</td>
                                                <td className='text-center'>
                                                    {i?.name}
                                                </td>
                                                <td className='text-center'>{i?.manufacturer?.name}</td>
                                                <td className='text-center'>
                                                    <div className="dropdown">
                                                        <TapIcon.imageIcon
                                                            icon={TapIcon.ListActionIcon}
                                                            alt="action-icon"
                                                            className="img-fluid px-3"
                                                            data-bs-toggle="dropdown"
                                                            href="#"
                                                            role="button"
                                                            aria-expanded="false"
                                                        />
                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => editModelInit(i)}
                                                                >
                                                                    Edit
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </>
                                        </tr>
                                    </>)
                                })
                                :
                                <tr><td colSpan="3" className="text-center">No Records</td></tr>
                        }
                    </tbody>
                </table>
                <DisplayListPagination meta={listingMeta} onPageChange={(e) => getModelListing(e.selected + 1)} />

            </>
        );
    };

    const modelJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3>Model Listing</h3>

                        <div className="text-end mt15">
                            <>
                                <Link to="/model_add">
                                    <button type="button" className="btn btn-primary">Add</button>
                                </Link>
                            </>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className='col-12'>
                            {modelListingJsx()}
                        </div>
                    </div>
                </div>
            </>
        );
    };


    return (
        <ApplicationLayout>
            <Helmet><title>Model Listing</title></Helmet>
            {modelJsx()}
        </ApplicationLayout>
    );
};

export default ModelListing;
